"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomConfirmDialog = void 0;
const confirmdialog_1 = require("primereact/confirmdialog");
const CustomConfirmDialog = (props) => {
    return (0, confirmdialog_1.confirmDialog)({
        message: props.message,
        header: props.header,
        icon: 'pi pi-info-circle',
        acceptLabel: props.acceptLabel || props.translation('yes'),
        rejectLabel: props.rejectLabel || props.translation('no'),
        accept: props.onConfirm,
        reject: props.onCancel ? props.onCancel : () => {
        },
        acceptClassName: props.acceptClassName,
        rejectClassName: props.rejectClassName
    });
};
exports.CustomConfirmDialog = CustomConfirmDialog;
